<template>
  <div>
    <h1 class="title">COME CI HAI CONOSCIUTO?</h1>

    <div class="subtitle">
      Vogliamo sapere come hai scoperto di noi!
      <strong>Seleziona sotto un'opzione</strong>
    </div>

    <form class="form max-w-md mx-auto" @submit.prevent>
      <div class="form-group">
        <label class="form-label">Come ci hai conosciuto?</label>
        <v-select
          class=""
          label="name"
          v-model.number="$v.form.knownThrough.$model"
          :reduce="(option) => option.id"
          :options="listData.howDidYouKnowUs"
        ></v-select>
        <div v-if="$v.form.knownThrough.$error" class="error">campo obbligatorio</div>
      </div>

      <div v-if="knownThroughProfessional">
        <div class="form-group">
          <label class="form-label" for="coupon_code">Inserisci qui il tuo codice</label>
          <div v-if="asyncState !== 'pending'">
            <input
              v-model="$v.form.couponCode.$model"
              type="text"
              placeholder=""
              class="form-control appearance-none"
              id="coupon_code"
            />
            <div
              v-if="$v.form.couponCode.$error && !$v.form.couponCode.required"
              class="error"
            >
              campo obbligatorio
            </div>
            <div v-if="showErrorMessage" class="error">{{ errorMessage }}</div>
          </div>
          <Loader :asyncState="asyncState"></Loader>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Loader from "./Loader";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
    listData: {
      type: Array,
      required: true,
    },
  },
  components: {
    vSelect,
    Loader,
  },
  data() {
    return {
      asyncState: null,
      errorMessage: "",
      form: {
        knownThrough: null,
        couponCode: null,
      },
    };
  },
  validations: {
    form: {
      knownThrough: {
        required,
      },
      couponCode: {
        required: requiredIf(function () {
          return this.knownThroughProfessional;
        }),
      },
    },
  },
  computed: {
    showErrorMessage() {
      return this.errorMessage !== "";
    },
    knownThroughProfessional() {
      return this.form.knownThrough == 1;
    },
  },
  watch: {
    "form.knownThrough": function (after) {
      if (after != 1) {
        this.form.couponCode = null;
        this.setErrorMessage("");
      }
    },
  },
  methods: {
    loaderAsyncState(state) {
      this.asyncState = state;
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            form: {
              knownThrough: this.form.knownThrough,
              couponCode: this.form.couponCode,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
    setErrorMessage(message) {
      this.errorMessage = message;
    },
  },
  mounted() {},
  activated() {
    this.form.knownThrough = this.wizardData.knownThrough;
    this.form.couponCode = this.wizardData.couponCode;
    this.$v.$reset();
  },
};
</script>
